import React from "react";

// Profile
import UserProfile from "../pages/Authentication/user-profile";
// category
import Category from "../pages/Categories/categories"
// Pages Calendar
//Email
// Authentication related pages
import Users from '../pages/UsersTable/Users'
import CreateUser from "../pages/UsersTable/CreateUser";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import DoctorForm from "../pages/DoctorForm/DoctorForm"
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import ConfirmPassword from "pages/Authentication/ConfirmPassword";
import Appointments from "pages/Appointments/Appointments";
import CatExercise from "pages/Categories/CatExercise";
import UserEdit from "pages/UsersTable/UserEdit"
import CategoryEdit from "pages/Categories/EditCategory"
import TimeSlotGenerator from "pages/DoctorForm/Time";
import CatExerciseEdit from "pages/Categories/EditCatExercise";
import CreateCategory from "pages/Categories/CreateCategory"
import CreateExercise from "pages/Categories/CreateCatExercise"
import DoctorListing from "pages/DoctorForm/DoctorListing";
import EditDoctor from "pages/DoctorForm/EditDoctor"
import SubCategories from "pages/Categories/SubCategories";
import EditSubCategories from "pages/Categories/EditSubCategories";
import CreateSubCategories from "pages/Categories/CreateSubCategories";
import VideosListing from "pages/Categories/CrudVideos/VideosListing";
import CreateVideos from "pages/Categories/CrudVideos/CreateVideos";
import EditCreateVideos from "pages/Categories/CrudVideos/EditVideos";

// Listing
import BodypartsListing from "pages/ListingBodyparts/bodypartsLi";
import Exercise from "pages/ListingExercise/Exercise";
import Videos from "pages/ListingVideos/Videos";



import Test from "../pages/Test/Test"
//  // Inner Authentication

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// notification

import SendNotification from "pages/Notifications/SendNotification";
import Signalnotifications from "pages/Notifications/Signalnotifications";
// Maps

//Icons

//Tables

// Forms

//Ui

//Pages

const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  // //calendar
  // //profile
  { path: "/profile", component: <UserProfile /> },



  // listing All Sub-categorys:
  { path: "/bodyparts", component: <BodypartsListing /> },
  { path: "/exercise", component: <Exercise /> },
  { path: "/videos", component: <Videos /> },



  //Category
  { path: "/category", component: <Category /> },
  { path: "/category/create-category", component: <CreateCategory /> },
  { path: "/category/edit/:id", component: <CategoryEdit /> },




  // Subcategory
  { path: "/category/sub-category/:id", component: <SubCategories /> },
  { path: "/category/edit-sub-category/:id", component: <EditSubCategories /> },
  { path: "/category/create-sub-category/:id", component: <CreateSubCategories /> },

  // Exercise 
  
  // { path: "/category/exercise/:slug", component: <CatExercise /> },
  // { path: "/category/edit-exercise/:id", component: <CatExerciseEdit /> },
  // { path: "/category/create-exercise/:id", component: <CreateExercise /> },

  { path: "/category/exercise/:subid/:slug", component: <CatExercise /> },
  { path: "/category/edit-exercise/:subid/:id", component: <CatExerciseEdit /> },
  { path: "/category/create-exercise/:subid/:id", component: <CreateExercise /> },


  // VideoListing
  // { path: "/category/exercise/videos/:id", component: <VideosListing /> },
  // { path: "/category/exercise/add-videos/:id", component: <CreateVideos /> },
  // { path: "/category/exercise/edit-video/:id", component: <EditCreateVideos /> },


  { path: "/category/videos/:subid/:exeid/:id", component: <VideosListing /> },
  { path: "/category/add-video/:subid/:exeid/:id", component: <CreateVideos /> },
  { path: "/category/edit-video/:subid/:exeid/:id", component: <EditCreateVideos /> },





  { path: "/doctor-form", component: <DoctorForm /> },
  { path: "/consultant", component: <DoctorListing /> },
  { path: "/edit-consultant/:userId", component: <EditDoctor /> },


  { path: "/time", component: <TimeSlotGenerator /> },

  { path: "/test", component: <Test /> },


  // Notificatin

  // { path: "/send-notifications", component: <SendNotification /> },
  { path: "/send-notifications", component: <Signalnotifications /> },


  //Charts
  // Icons
  // Tables
  { path: "/users", component: <Users /> },
  { path: "/users/:slug", component: <UserEdit /> },
  { path: "/users/create-user", component: <CreateUser /> },


  { path: "/appoitments", component: <Appointments /> },

  // Maps
  // Forms
  // Ui
  //Utility
  // this route should be at the end of all other routes
  { path: "/", component: <Dashboard /> },
];

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/confirm-password/:token", component: <ConfirmPassword /> },

  // { path: "/pages-maintenance", component: <PagesMaintenance /> },
  // { path: "/pages-comingsoon", component: <PagesComingsoon /> },
  // { path: "/pages-404", component: <Pages404 /> },
  // { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner

];

export { userRoutes, authRoutes };
